// Npm
import React, { FC, memo, ReactElement, useEffect } from 'react';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';

// Local
import { store } from './app/store';
import Routes from './routes';
import { UsersProvider } from './store/UsersContext';
import { messages } from './translations';
import 'xps-style/dist/xps-style.css';

/**
 * @param {*} {}
 * @return {ReactElement}
 */
const App: FC = (): ReactElement => {
  const persistor = persistStore(store);
  const locale = navigator.language.split(/[-_]/)[0]; // language without region code

  useEffect(() => {
    if (window.top !== window.self) {
      document.body.textContent = 'This site cannot be loaded in an iframe';
    }
  }, []);

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <UsersProvider>
          <IntlProvider locale={locale} messages={messages[locale]}>
            <Routes />
          </IntlProvider>
        </UsersProvider>
      </PersistGate>
    </Provider>
  );
};

export default memo(App);
